import { useRecoilState } from "recoil";
import { isUrlCheckModalOpenState } from "../../../recoil/admin/examRoom";
import Modal from "../../modules/layout/Modal";
import React from "react";

const AdminUrlModal = ({ isGroupId }) => {
  const [isUrlCheckModalOpen, setUrlCheckModalOpen] = useRecoilState(
    isUrlCheckModalOpenState
  );

  return (
    <Modal isOpen={isUrlCheckModalOpen}>
      <div className="modal fade" id="url" style={{ display: "block" }}>
        <div className="modal-content">
          <div className="modal-header flex">
            <div className="modal-title">
              <p>영어말하기 모의평가</p>
            </div>
          </div>
          <div className="modal-body confirm-sec">
            <div className="plus-box">
              <p className="plus-title">접수 URL</p>
              <input
                type="text"
                style={{ width: "100%" }}
                disabled={true}
                value={window.location.host + "/receipt/" + isGroupId}
              />
            </div>
            <div className="text-align-center">
              <button
                type="button"
                className="btn-custom b-btn url-copy"
                onClick={() => {
                  navigator.clipboard
                    .writeText(window.location.host + "/receipt/" + isGroupId)
                    .then(() => {
                      alert("복사되었습니다.");
                    });
                }}
              >
                복사하기
              </button>
            </div>
            <div className="plus-box">
              <p className="plus-title">응시 URL</p>
              <input
                type="text"
                style={{ width: "100%" }}
                disabled={true}
                value={window.location.host + "/apply/" + isGroupId}
              />
            </div>
            <div className="text-align-center">
              <button
                type="button"
                className="btn-custom b-btn url-copy"
                onClick={() => {
                  navigator.clipboard
                    .writeText(window.location.host + "/apply/" + isGroupId)
                    .then(() => {
                      alert("복사되었습니다.");
                    });
                }}
              >
                복사하기
              </button>
            </div>
            <div className="modal-footer text-align-right">
              <button
                type="button"
                className="modal-btn modal-close-btn"
                onClick={() => {
                  setUrlCheckModalOpen(false);
                }}
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default AdminUrlModal;
